import React, { useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap-5';
import { faDownload, faFileDoc, faFilePdf } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { exportAllMailers, profileMailerExportsUrl } from 'bundles/connect/helpers/prospect_api';
import { displayToast } from 'bundles/connect/helpers/display_toast';

type MailersDownloadAllProps = {
  callListId: number;
  templateId: number;
}

export default function MailersDownloadAll({ callListId, templateId }: MailersDownloadAllProps) {
  const [show, setShow] = useState(false);
  const [name, setName] = useState('');
  const [savingDocx, setSavingDocx] = useState(false);
  const [savingPdf, setSavingPdf] = useState(false);

  const handleClose = () => {
    setName('');
    setShow(false);
  };

  const handleDownloadAll = (exportType: 'docx' | 'pdf') => {
    if (exportType === 'docx') {
      setSavingDocx(true);
    } else {
      setSavingPdf(true);
    }
    const params = {
      export: {
        connect_call_list_id: callListId,
        connect_mailer_template_id: templateId,
        export_type: exportType,
        name
      }
    };
    exportAllMailers(callListId, params).then(() => {
      displayToast(
        `Download in progress. Navigate to your <a href="${profileMailerExportsUrl}">Profile Settings</a> to download your export`,
        'success'
      );
    }).finally(() => {
      handleClose();
      setName('');
      setSavingDocx(false);
      setSavingPdf(false);
    });
  };

  return (
    <>
      <Button variant="secondary" onClick={() => setShow(true)}>
        <FontAwesomeIcon className="me-2" icon={faDownload} />
        Download All
      </Button>
      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Download All Mailers</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-3">
          <div className="d-flex flex-column gap-2">
            <Form.Label className="mb-0">Export Name</Form.Label>
            <Form.Control placeholder="Export Name" type="text" onChange={e => setName(e.target.value)} />
          </div>
          <div className="border-top" />
          <div>
            Please select your download format from the options below.
          </div>
          <div className="d-flex gap-2">
            <Button
              className="flex-grow-1"
              disabled={name.length < 1 || savingDocx || savingPdf}
              variant="outline-secondary"
              onClick={() => handleDownloadAll('docx')}
            >
              { savingDocx ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={faFileDoc} /> }
              Download as Docx
            </Button>
            <Button
              className="flex-grow-1"
              disabled={name.length < 1 || savingPdf || savingDocx}
              variant="outline-secondary"
              onClick={() => handleDownloadAll('pdf')}
            >
              { savingPdf ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={faFilePdf} /> }
              Download as PDF
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="text-primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
